// Shared NEXOVA tone vocabulary for badges / pills / status chips.
//
// Each tone maps to a soft-tinted background + the matching foreground from the
// nx-* token set (see src/index.css). Kept in one place so Badge tones,
// StatusPill, and Stepper stay visually consistent.

export type Tone =
  | "brand"
  | "credit"
  | "debit"
  | "profit"
  | "live"
  | "stale"
  | "warn"
  | "danger"
  | "manual"
  | "na";

export const toneSoftClass: Record<Tone, string> = {
  brand: "bg-nx-brand-soft text-nx-brand",
  credit: "bg-nx-credit-soft text-nx-credit",
  debit: "bg-nx-debit-soft text-nx-debit",
  profit: "bg-nx-profit-soft text-nx-profit",
  live: "bg-nx-live-soft text-nx-live",
  stale: "bg-nx-stale-soft text-nx-stale",
  warn: "bg-nx-warn-soft text-nx-warn",
  danger: "bg-nx-danger-soft text-nx-danger",
  manual: "bg-nx-manual-soft text-nx-manual",
  na: "bg-nx-na-soft text-nx-na",
};

export const toneDotClass: Record<Tone, string> = {
  brand: "bg-nx-brand",
  credit: "bg-nx-credit",
  debit: "bg-nx-debit",
  profit: "bg-nx-profit",
  live: "bg-nx-live",
  stale: "bg-nx-stale",
  warn: "bg-nx-warn",
  danger: "bg-nx-danger",
  manual: "bg-nx-manual",
  na: "bg-nx-na",
};
